module.exports = {
  MAX_PLAYERS: "mC",
  IS_PRIVATE: "pv",
  AUTO_SEEK: "sk"
};